import React from 'react';
import { useTranslation } from 'react-i18next';

const CompareView: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('readback.compare')}
      </h3>
      <p className="text-sm text-gray-400">
        Compare on-target flash contents with the firmware file from Google Drive.
      </p>
    </div>
  );
};

export default CompareView;
